import { debug } from './utils';

// Represents a 9x9 Sudoku grid
export type SudokuGrid = number[][];
const level4Puzzles = [  // From http://forum.enjoysudoku.com/superior-plus-puzzles-t4414.html
    '...........87.61...321.594...98.3.2...........4.9.13...173.859...36.78...........',
    '8..5....9....6.4...632..5........3.8.2.....6.9.5........8..192...9.8....7....9..4',
    '...2......365.8...1.8.6..7......64..9.......5..58......9..4.7.3...7.186......9...',
    '.......1.21...348..398..2...6.3.49.............16.7.4...8..217..267...98.9.......',
    '..1..7....68.1....4..6.......478...967...3.2...5..24.....9.8.51....3..8.....6.2..',
    '2.458......3.4.....9.1.6......39.2.......2.8581...53.4.......56...7..1..5..8....2',
    '..8............5.33..47.2.6..48.9.....1..639....24.....85.2..3.....9.4.7.46....5.',
    '1............234.....54..6...3..5.2..78...53..4.6..9...8..62.....295............7',
    '...1...2...3.45..6.4..7....2......8..87...45..9......1....5..3.9..73.8...1...8...',
    '.....813..41..62...5....4.........8...46.57...7.........3....7...51..89..169.....',
    '.....1.......2.34....5...16..7...8...2...6..58...3.7...6.4.2....52.....8..9.5..3.',
    '.2.6........9.1..8..3.4.1...7.....64..8...2..53.....7...9.1.7..8..3.5........2.5.',
    '41..9.8.3....2...57..6...........9..92.....81..5...........5..43...1....5.7.3..29',
    '..........4.....1...92.63....6.1.7.....4.5.....7.3.2....27.96...3.....5..........',
    '..........1.....2...34.56....4.1.3.....7.8.....6.9.5....25.64...7.....9..........',
    '..........1.....2...34.56....4.1.5.....2.7.....8.6.3....63.48...7.....9..........',
    '............1.23..45.....61.4.....1....2.7....6.....8.91.....46..73.8............',
    '..1.23..4.....5...6.....7.........137.......689.........5.....7...4.....1..79.4..',
    '...2.86...4.....1.9...3....4..7.9..6..6...5..2..1.3..4....2...7.5.....6...23.7...',
    '..7...43.2....8...3...5...2.7..4......85.67......3..5.9...2...8...4....3.62...1..',
    '34..5...9..5.....6..2...87....3.4...7.......4...1.6....83...2..6.....4..9...2..13',
    '8.3.2.7..1.678.9.......3...6......7..7.86..1.9......5......9...3.947.1..4.7.1.6..',
    '2....38....82.....3..4..2.1.65.....972........3.5..41......6.9....915.......7.5.8',
    '2....38.4..82.....3..4..2.1.65.....972........3....41......6.9....915.......7.5.8',
    '1..93..74.2...7.......1..8.93..4.8...1.....6...6.8..39.7..6.......5...4.59..71..6',
    '9..4..7...6..3..5...1..8..42..8..1...3..4..7...7..9..55..6..2...2..8..9...6..1..3',
    '8..6..4...9..1..3...7..8..56..4..1...1..2..8...8..9..65..9..2...6..3..7...4..5..3',
    '2..4..3...7..8..4...4..7..14..1..2...5..6..3...7..8..95..8..7...6..5..9...1..9..6',
    '9.38...6....6...8.......9.5..23...5.4...6...1.5...78..3.5.......7...3....6...12.9',
    '.....3.655..6..72...6.....323..675.....8.4.....832..976.....1...57..6..831.5.....',
    '..7......53.1....79.1...54....6.7.35..3.5.9..86.3.4....28...3.93....2.74......1..',
    '6...9.3....7...62..2.....15...5.4...7.......3...1.2...41.....7..36...8....5.6...9',
    '7...4...6.6.....8...43.29....29.41..4...3...9..76.83....51.36...7.....1.9...8...4',
    '.........9..3.2..464.1.8.7971.....28..5...7..42.....9515.9.4.622..5.6..1.........',
    '.128...3.7..3....1....61..7..57.6.13..9...7..67.1.59..5..41....3....9..2.4...315.',
    '4...2...8.3.....5.8.9.5.1.2...297.....4...5.....514...5.8.4.6.1.1.....3.2...6...5',
    '6...8...9.15...28..3.....4....321...2..4.6..7...798....4.....1..62...43.3...4...5',
    '..72.89.....1.3.....2...8..2.......495.7.2.16.14...28..8.....5.4.......2..19.56..',
//    "763.1.4.9..8.7..5........6.1.6.8.3...........3.9.4.7.2........1..7.6..3.8.4.296.",  0 solutions
    '..95.....7..9...4...87.31..425.....................756..68.13...9...6..1.....49..',
    '.35...48.7..3.2...1.......9.4.9.1.7...........1.6.3.5.9.......5...8.7..3.86...72.',
    '93..21.47......8..6...8..3....2...6.1.........9...4..2.1..5...3..3......74.86..51',
    '.7..8.4...4.7.2...2.5.3...7..8....1...6.5.7.879.....3.9...658.....8...79..12..3..',
    '....41....8..9....2.45.3.......1.6.4...9.2.57....7.1..961...4....7....9...5...2..',
    '2...6...9.1.....2...91.84....42.75..5...9...4..65.19....74.26...5.....4.9...7...3',
    '.475.6.9.6.......41.3...5.2..86.7.3............49.2.5.4.2...8.55.......3.364.5.2.',
    '7...4..59..39..2.8.2.....3.....81...3..6.5..4...47.....4.....8.8.1..94..96..3...7',
    '....6......67.25....98.51...63...84.8.......3.57...92...85.73....56.92......2....',
    '..........389.265..5.6.4.2..91...87...........45...93..6.7.3.4..725.819..........',
    '....41....8..9....2.45.3.......1.6.4...9.2.57....7.1..961...4....7....9...5...2..',
    '..8.....7.1....5..9......34.....2.......384.....94.825.6..25.1...2..36.93.5..6.4.',
    '..26.3..8..9..12......7..3.6....89...5.....7...37....4.3..5......51..8..2..9.61..',
    '..3.7.9....15.96..5..6.3..7..........18...25.4..1.5..91..9.6..4..........5.7.1.8.',
    '.7..4........3...5...8..1..4.3....2....5.19..6.........5.9..7..2......4..........',
    '...7.13.8.7....21......6.97...18...2.9.....8.5...69...73.2......81....2.9.28.7...',
    '..45.89168....2.....54......2.3..1.4.........7.3..1.2......32.....1....96482.93..',
    '..6.5........2785..2.9....78..6.9.7.6...4...3.5.2.8..17....2.4..6519........7.1..',
    '..71....515..2....8.273..6.2....7.8...4.1.5...8.6....7.2..734.6....6..714....18..',
    '.64.1.....295.6..47...23...6....7..3..3.6.5..9..3....7...19...64..7.293.....3.71.',
    '17...34...4...73....6.9..1.2..8.91.6....6....8.73.1..4.9..1.7....37...9...19...42',
    '.....827..2......38...31...2568......3.....5......3982...67...51......2..623.....',
    '..826.7...1.....2.4.6..7.8.164...8......8......9...417.9.6..2.5.8.....4...2.159..',
    '.5..6..9.........7..92.43....7.138..4..6.2..1..584.9....27.84..3.........7..2..5.',
    '..9.5..8...3..12..7..2....11..8..345.........6..4..9128..6....4..7..98....6.4..2.',
    '8..3..71.......4.57..6.4.3..5.7.....4...5...7.....1.8..4.5.6..22.3.......76..8..4',
    '24.9...35...5..28.5.6.1...9....45.63.........63.89....3...2.5.4.52..8...19...3.28',
    '..5...3..9...2..87.....1...25..1.79.4...7...2.83.9..51...7.....39..4...8..4...2..',
    '.328..69...9.5...1.8...9....5.2..7..9...6...2..7..3.5....5...3.8...2.5...25..716.',
    '.7.1.29...563.....2......36.3...62..7...4...3..95...6.54......1.....537...36.4.5.',
    '7.....8...6.8..2.9.9..4..714.26......1.7.5.9......46.265..7..4.1.7..9.2...9.....7',
    '.37.6.91............57.82...9.2.6...5...8...4...1.4.3...68.94............29.1.86.',
    '....4.7...4.7..63...16.9..47..38.9...8.....6...3.96..74..5.83...37..4.5...8.1....',
    '..4.1..8.2..6.....5.1.2....67...9.1....762....2.5...97....9.7.5.....6..8.1..8.9..',
    '..5...3..9...2...7...3..92..564...93....7....78...645..68..2...3...4...8..4...2..',
    '7...46.5..13.......64.....3...6.2.9.9.6.7.2.1.2.1.9...3.....41.......57..5.91...6',
    '...2.17..2.35.....7.9.3...5.....62...5.....6...28.....8...2.5.9.....51.8..19.7...',
    '.4....19.....42..7.....75....24....8.6.291.5.4....82....95.....8..67.....75....8.',
    '1..86.3..34.7.2.....8.39.1..3.....79..4...6..79.....4..8.67.1.....9.1.27..7.23..8',
    '2...4...55987..3...4..589...3.8..4...7.....3...5..2.9...926..4...4..96736...8...9',
    '.31...72....9.86......7.....5.....4...27.63...8.....1.....9......85.4....63...89.',
    '..69.23...........2...8...43...7...1..95.68..5...4...61...6...7...........82.46..',
    '.....75268.52.....7..4.....5.....892.........629.....7.....5..1.....64.84368.....',
    '...12..8......87....6.3.2.5.5...2.7...2.7.3...3.8...4.8.7.1.4....34......2..65...',
    '..5.2.68....6........9.72...58....7..42.7.36..3....54...72.3........9....24.6.8..',
    '.75.24...2.......4.86....1...8..2....4.571.6....8..5...9....45.5.......7...76.89.',
    '3......89.1.6.......6..72..6..34..7.9.2.7.3.8.3..96..2..72..4.......9.2.12......3',
    '3.5.2.....19.58..4...9.......8...9..94.5.1.68..1...5.......3...5..48.12.....6.8.3',
    '...4..8..1.6.....49...6.213...1.3.2.32..4..67.7.6.2...793.1...28.....1.9..4..6...',
    '..6..2...3.271..4.8.....2.77.92...1.....4.....1...73.99.7.....3.4..987.6...4..1..',
    '.5..4.1.6.4.5.....8.17.9...3.49...1...........1...64.8...3.86.4.....1.9.4.8.9..3.',
    '5.3.1.....625.9...9...2.7....1.....5.9.352.1.6.....2....7.6...2...1.546.....4.9.1',
    '8.3.....91..2......7..1.5...284...7....598....4...289...5.2..8......9..24.....7.6',
    '..8.125..3.146..2.5..8....18..5......32...65......6..84....3..5.8..512.4..598.1..',
    '3.42.78.9...9.5............7.9...5.8.........2.8...3.4....7.....7.6.9.3.9.38.47.2',
    '..7..1..8.5..3..2.......7....9..2..6.3..9..5.6..3..1....1.......6..4..9.7..8..3..'];

// Seeded random number generator
class SeededRandom {
    private seed: number;
    private readonly a = 1664525;        // Multiplier
    private readonly c = 1013904223;     // Increment
    private readonly m = 4294967296;     // Modulus (2^32)

    constructor(seed: number) {
        // Validate the seed
        debug('Type of seed:', typeof seed);
        debug('Seed:', seed);
        if (typeof seed !== 'number' || isNaN(seed) || !isFinite(seed)) {
            throw new Error('Seed must be a finite number');
        }
        // Initialize seed within the modulus range
        this.seed = seed % this.m;
    }

    // Generate random number between 0 and 1
    random(): number {
        // Update seed using LCG formula
        this.seed = (this.a * this.seed + this.c) % this.m;
        // Return value between 0 and 1
        return this.seed / this.m;
    }
}

// ShuffleArray using seeded random
function shuffleArray<T>(array: T[], rng: SeededRandom): void {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.min(i, Math.floor(rng.random() * (i + 1)));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

// Returns possible numbers that can be placed at grid[row][col]
function getPossibleNumbers(grid: SudokuGrid, row: number, col: number): number[] {
    const possible = Array(10).fill(true); // Index 0 unused

    // Check row
    for (let j = 0; j < 9; j++) {
        if (grid[row][j] !== 0) possible[grid[row][j]] = false;
    }

    // Check column
    for (let i = 0; i < 9; i++) {
        if (grid[i][col] !== 0) possible[grid[i][col]] = false;
    }

    // Check 3x3 block
    const blockRowStart = Math.floor(row / 3) * 3;
    const blockColStart = Math.floor(col / 3) * 3;
    for (let i = blockRowStart; i < blockRowStart + 3; i++) {
        for (let j = blockColStart; j < blockColStart + 3; j++) {
            if (grid[i][j] !== 0) possible[grid[i][j]] = false;
        }
    }

    // Collect possible numbers
    const result: number[] = [];
    for (let num = 1; num <= 9; num++) {
        if (possible[num]) result.push(num);
    }
    return result;
}

// Fills the grid using backtracking, starting from position pos (0 to 80)
function fillGrid(grid: SudokuGrid, pos: number, rng: SeededRandom): boolean {
    if (pos === 81) return true; // Grid is fully filled

    const row = Math.floor(pos / 9);
    const col = pos % 9;

    if (grid[row][col] !== 0) return fillGrid(grid, pos + 1, rng);

    const possibleNumbers = getPossibleNumbers(grid, row, col);
    shuffleArray(possibleNumbers, rng); // Pass rng

    for (const num of possibleNumbers) {
        grid[row][col] = num;
        if (fillGrid(grid, pos + 1, rng)) return true;
        grid[row][col] = 0; // Backtrack
    }
    return false;
}

// Generates a fully solved Sudoku grid
function generateSolvedGrid(rng: SeededRandom): SudokuGrid {
    const grid: SudokuGrid = Array.from({ length: 9 }, () => Array(9).fill(0));
    fillGrid(grid, 0, rng);
    return grid;
}

// Counts the number of solutions for a grid, stopping at 2
function countSolutions(grid: SudokuGrid): number {
    const gridCopy = grid.map(row => row.slice()); // Avoid modifying original
    const solutions = [0]; // Mutable counter

    function solve(pos: number): void {
        if (solutions[0] >= 2) return; // Stop if 2 solutions found
        if (pos === 81) { // Grid is fully filled
            solutions[0]++;
            return;
        }

        const row = Math.floor(pos / 9);
        const col = pos % 9;

        if (gridCopy[row][col] !== 0) {
            solve(pos + 1);
            return;
        }

        const possibleNumbers = getPossibleNumbers(gridCopy, row, col);
        for (const num of possibleNumbers) {
            gridCopy[row][col] = num;
            solve(pos + 1);
            if (solutions[0] >= 2) return;
            gridCopy[row][col] = 0; // Backtrack
        }
    }

    solve(0);
    return solutions[0];
}

// Returns symmetric position based on chosen symmetry method
function getSymmetricPosition(row: number, col: number, symmetryMethod: number): [number, number] {
    switch (symmetryMethod) {
        case 1: // 180° rotation
            return [8-row, 8-col];
        case 2: // Horizontal reflection
            return [8-row, col];
        case 3: // Vertical reflection
            return [row, 8-col];
        case 4: // Main diagonal
            return [col, row];
        case 5: // Anti-diagonal
            return [8-col, 8-row];
        default:
            throw new Error('Invalid symmetry method');
    }
}

// Creates a puzzle with symmetrical clue removal
function createSymmetricPuzzle(solvedGrid: SudokuGrid, rng: SeededRandom, symmetryMethod: number, difficulty = 3): SudokuGrid {
    const puzzle = solvedGrid.map(row => row.slice()); // Deep copy
    const cells: [number, number][] = [];

    // List all cell coordinates except the center
    for (let i = 0; i < 9; i++) {
        for (let j = 0; j < 9; j++) {
            if (!(i === 4 && j === 4)) { // Skip center cell initially
                cells.push([i, j]);
            }
        }
    }

    shuffleArray(cells, rng); // Randomize removal order

    // Process cells, removing symmetric pairs
    const processed = new Set<string>();
    // Keep track of successfully removed pairs for easier difficulties
    const removedPairs: Array<[[number, number], [number, number]]> = [];

    for (const [i, j] of cells) {
        const cellKey = `${i},${j}`;
        if (processed.has(cellKey)) continue;

        const [symI, symJ] = getSymmetricPosition(i, j, symmetryMethod);
        const symKey = `${symI},${symJ}`;

        // Skip if this would affect the center cell (self-symmetric)
        if ((i === 4 && j === 4) || (symI === 4 && symJ === 4)) continue;

        // Mark both cells as processed
        processed.add(cellKey);
        processed.add(symKey);

        // Try removing the symmetric pair
        const temp1 = puzzle[i][j];
        const temp2 = puzzle[symI][symJ];

        puzzle[i][j] = 0;
        puzzle[symI][symJ] = 0;

        if (countSolutions(puzzle) !== 1) {
            // Restore if uniqueness is lost
            puzzle[i][j] = temp1;
            puzzle[symI][symJ] = temp2;
        } else {
            // Store the successfully removed pair
            removedPairs.push([[i, j], [symI, symJ]]);
        }
    }

    // Finally, try removing the center cell if it helps
    let centerRemoved = false;
    if (countSolutions(puzzle) === 1 && puzzle[4][4] !== 0) {
        const tempCenter = puzzle[4][4];
        puzzle[4][4] = 0;

        if (countSolutions(puzzle) !== 1) {
            // Restore center if uniqueness is lost
            puzzle[4][4] = tempCenter;
        } else {
            centerRemoved = true;
        }
    }

    // Add back removed pairs based on difficulty
    const pairsToAddBack = difficulty === 1 ? 6 :
                           difficulty === 2 ? 3 :
                           0;

    if (pairsToAddBack > 0 && removedPairs.length > 0) {
        // Add back the last n pairs that were removed
        const pairsToRestore = removedPairs.slice(-Math.min(pairsToAddBack, removedPairs.length));
        debug('pairsToRestore', pairsToRestore);

        for (const [[i, j], [symI, symJ]] of pairsToRestore) {
            puzzle[i][j] = solvedGrid[i][j];
            puzzle[symI][symJ] = solvedGrid[symI][symJ];
        }

        // If center was removed and we're adding back clues, consider adding it back too for difficulty 1
        if (centerRemoved && difficulty === 1) {
            puzzle[4][4] = solvedGrid[4][4];
        }
    }

    return puzzle;
}

// Converts a string representation to a SudokuGrid
function stringToPuzzleGrid(puzzleString: string): SudokuGrid {
    const grid: SudokuGrid = Array.from({ length: 9 }, () => Array(9).fill(0));

    for (let i = 0; i < 81; i++) {
        const row = Math.floor(i / 9);
        const col = i % 9;
        const char = puzzleString.charAt(i);

        grid[row][col] = char === '.' ? 0 : parseInt(char);
    }

    return grid;
}

// Generate Sudoku puzzle with symmetry
export function generateSudokuPuzzle(seed: number, difficulty = 3, symmetryMethod?: number) {
    debug('generateSudokuPuzzle using seed', seed, 'difficulty', difficulty);
    const rng = new SeededRandom(seed);

    // If no symmetry method specified, randomly select one
    const actualSymmetryMethod = symmetryMethod || Math.floor(rng.random() * 5) + 1;

    // Make sure difficulty is within valid range (1-4)
    const validDifficulty = Math.max(1, Math.min(4, difficulty));

    // For difficulty 4, select a puzzle from level4Puzzles
    if (validDifficulty === 4) {
        // Select a random puzzle using the seeded RNG
        const puzzleIndex = Math.floor(rng.random() * level4Puzzles.length);
        const puzzleString = level4Puzzles[puzzleIndex];
        debug('puzzleIndex', puzzleIndex);
        debug('puzzleString', puzzleString);

        // Convert string to grid format
        const {puzzle, solution, transformations} = applyRandomTransformations(seed);
        debug('transformations', transformations);

        // Solve the puzzle to get the solution
        fillGrid(solution, 0, rng);

        return {
            puzzle: puzzle,
            solution: solution,
            symmetryMethod: actualSymmetryMethod
        };
    }

    // For difficulties 1-3, use the existing approach
    const solvedGrid = generateSolvedGrid(rng);
    const puzzle = createSymmetricPuzzle(solvedGrid, rng, actualSymmetryMethod, validDifficulty);

    return {
        puzzle: puzzle,
        solution: solvedGrid,
        symmetryMethod: actualSymmetryMethod
    };
}

// Shift rows in a grid (shift of 3 means rows 1,2,3 become 4,5,6, etc., wrapping around)
function shiftRows(grid: SudokuGrid, shift: number): SudokuGrid {
    const result: SudokuGrid = Array.from({ length: 9 }, () => Array(9).fill(0));
    for (let i = 0; i < 9; i++) {
        const newRow = (i + shift) % 9;
        result[newRow] = [...grid[i]];
    }
    return result;
}

// Shift columns in a grid
function shiftColumns(grid: SudokuGrid, shift: number): SudokuGrid {
    const result: SudokuGrid = Array.from({ length: 9 }, () => Array(9).fill(0));
    for (let i = 0; i < 9; i++) {
        for (let j = 0; j < 9; j++) {
            const newCol = (j + shift) % 9;
            result[i][newCol] = grid[i][j];
        }
    }
    return result;
}

// Rotate grid by specified degrees (90, 180, 270)
function rotateGrid(grid: SudokuGrid, degrees: number): SudokuGrid {
    const result: SudokuGrid = Array.from({ length: 9 }, () => Array(9).fill(0));
    const numRotations = (degrees / 90) % 4;

    for (let r = 0; r < numRotations; r++) {
        // Single 90-degree rotation
        for (let i = 0; i < 9; i++) {
            for (let j = 0; j < 9; j++) {
                result[j][8 - i] = grid[i][j];
            }
        }
        // Copy result back to grid for multiple rotations
        if (r < numRotations - 1) {
            for (let i = 0; i < 9; i++) {
                grid[i] = [...result[i]];
            }
        }
    }
    return result;
}

// Flip grid in specified direction
function flipGrid(grid: SudokuGrid, direction: 'horizontal' | 'vertical' | 'mainDiagonal' | 'secondaryDiagonal'): SudokuGrid {
    const result: SudokuGrid = Array.from({ length: 9 }, () => Array(9).fill(0));

    switch (direction) {
        case 'horizontal':
            for (let i = 0; i < 9; i++) {
                for (let j = 0; j < 9; j++) {
                    result[8 - i][j] = grid[i][j];
                }
            }
            break;
        case 'vertical':
            for (let i = 0; i < 9; i++) {
                for (let j = 0; j < 9; j++) {
                    result[i][8 - j] = grid[i][j];
                }
            }
            break;
        case 'mainDiagonal':
            for (let i = 0; i < 9; i++) {
                for (let j = 0; j < 9; j++) {
                    result[j][i] = grid[i][j];
                }
            }
            break;
        case 'secondaryDiagonal':
            for (let i = 0; i < 9; i++) {
                for (let j = 0; j < 9; j++) {
                    result[8 - j][8 - i] = grid[i][j];
                }
            }
            break;
    }
    return result;
}

// Shift digit values (e.g., 1→2, 2→3, etc., wrapping around from 9 to 1)
function shiftDigits(grid: SudokuGrid, shift: number): SudokuGrid {
    const result: SudokuGrid = Array.from({ length: 9 }, () => Array(9).fill(0));
    for (let i = 0; i < 9; i++) {
        for (let j = 0; j < 9; j++) {
            if (grid[i][j] !== 0) {
                // We add 8 and modulo 9, then add 1 to ensure the result is between 1-9
                result[i][j] = ((grid[i][j] - 1 + shift) % 9) + 1;
            }
        }
    }
    return result;
}

// Apply random transformations to a puzzle and verify uniqueness
export function applyRandomTransformations(seed: number): {
    puzzle: SudokuGrid,
    solution: SudokuGrid,
    transformations: string[]
} {
    const rng = new SeededRandom(seed);

    // Select a random puzzle from level4Puzzles
    const puzzleIndex = Math.floor(rng.random() * level4Puzzles.length);
    const puzzleString = level4Puzzles[puzzleIndex];
    let puzzle = stringToPuzzleGrid(puzzleString);

    // Create a record of applied transformations
    const transformations: string[] = [];
    transformations.push(`Selected puzzle index: ${puzzleIndex}`);

    // Randomly decide whether to apply each transformation
    // 1. Shift rows
    const shiftRowsRandom = rng.random();
    if (shiftRowsRandom > 0.33) {
        const shift = rng.random() < 0.5 ? 3 : 6; // Either shift by 3 or 6 (equivalent to -3)
        puzzle = shiftRows(puzzle, shift);
        transformations.push(`Shifted rows by ${shift}`);
    } else {
        transformations.push(`Did not shift rows (shiftRowsRandom: ${shiftRowsRandom})`);
    }

    // 2. Shift columns
    const shiftColumnsRandom = rng.random();
    if (shiftColumnsRandom > 0.33) {
        const shift = rng.random() < 0.5 ? 3 : 6; // Either shift by 3 or 6 (equivalent to -3)
        puzzle = shiftColumns(puzzle, shift);
        transformations.push(`Shifted columns by ${shift}`);
    } else {
        transformations.push(`Did not shift columns (shiftColumnsRandom: ${shiftColumnsRandom})`);
    }

    // 3. Rotate grid
    const rotateGridRandom = rng.random();
    if (rotateGridRandom > 0.25) {
        const degrees = [90, 180, 270][Math.floor(rng.random() * 3)];
        puzzle = rotateGrid(puzzle, degrees);
        transformations.push(`Rotated by ${degrees} degrees`);
    } else {
        transformations.push(`Did not rotate grid (rotateGridRandom: ${rotateGridRandom})`);
    }

    // 4. Flip grid
    const flipGridRandom = rng.random();
    if (flipGridRandom > 0.2) {
        const directions = ['horizontal', 'vertical', 'mainDiagonal', 'secondaryDiagonal'];
        const direction = directions[Math.floor(rng.random() * 4)] as 'horizontal' | 'vertical' | 'mainDiagonal' | 'secondaryDiagonal';
        puzzle = flipGrid(puzzle, direction);
        transformations.push(`Flipped ${direction}`);
    } else {
        transformations.push(`Did not flip grid (flipGridRandom: ${flipGridRandom})`);
    }

    // 5. Shift digits
    const shiftDigitsRandom = rng.random();
    if (shiftDigitsRandom > 0.11) {
        // Shift by 1-8 positions
        const shift = 1 + Math.floor(rng.random() * 8);
        puzzle = shiftDigits(puzzle, shift);
        transformations.push(`Shifted digit values by ${shift}`);
    } else {
        transformations.push(`Did not shift digits (shiftDigitsRandom: ${shiftDigitsRandom})`);
    }

    // Verify that the transformed puzzle still has exactly one solution
    const solutionCount = countSolutions(puzzle);
    if (solutionCount !== 1) {
        console.warn(`Transformed puzzle has ${solutionCount} solutions instead of 1. Using original puzzle.`);
        // Fall back to the original puzzle if uniqueness is lost
        puzzle = stringToPuzzleGrid(puzzleString);
        transformations.push('⚠️ Transformations reset - uniqueness was lost');
    }

    // Create a solution by solving the transformed puzzle
    const solution = puzzle.map(row => row.slice());
    fillGrid(solution, 0, rng);

    return {
        puzzle,
        solution,
        transformations
    };
}

// Verify that all level4Puzzles have exactly one solution
export function verifyLevel4Puzzles(): { valid: boolean, invalidPuzzles: { index: number, solutions: number }[] } {
    const invalidPuzzles: { index: number, solutions: number }[] = [];

    // Check each puzzle
    for (let i = 0; i < level4Puzzles.length; i++) {
        const puzzleString = level4Puzzles[i];
        const grid = stringToPuzzleGrid(puzzleString);

        // Count solutions (will stop at 2)
        const solutions = countSolutions(grid);

        // If not exactly 1 solution, add to invalid list
        if (solutions !== 1) {
            invalidPuzzles.push({ index: i, solutions });
        }

        // Optional: add progress logging
        if (i % 10 === 0) {
            debug(`Verified ${i} of ${level4Puzzles.length} puzzles...`);
        }
    }

    // Return results
    return {
        valid: invalidPuzzles.length === 0,
        invalidPuzzles
    };
}

// Usage example (can be commented out)
// debug(verifyLevel4Puzzles());
